<template>
  <v-menu
    bottom
    left
    min-width="200"
    offset-y
    origin="top right"
    transition="scale-transition"
  >
    <template v-slot:activator="{ attrs, on }">
      <v-btn
        class="ml-2"
        min-width="0"
        text
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-account</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item
        v-for="(item, index) in items"
        :key="index"
        @click="menuClick(item.to)"
      >
        <v-list-item-title>{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  export default {
    name: 'DefaultAccount',
    status: '',

    data: () => ({
      items: [
        { title: 'Profile', to: 'APP_GO_PROFILE' },
        { title: 'Log out', to: 'APP_LOGOUT' },
      ],
    }),

    methods: {
      menuClick (to) {
        this.status = to
        window.getApp.$emit(to)
      },
    },
  }
</script>
